import { createAsyncThunk } from "@reduxjs/toolkit";
import { appName } from "../../constants/defaultValues";

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  setCustomer,
  getCustomer,
  setAuth
} from "../../utils/helpers";

import {
  notification
} from "../actions";

export const getCustomerByEmail = createAsyncThunk("getCustomerByEmail", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.get(`/v1/by_email/?email=${payload.email}`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      if (payload.showNotification){
        thunkAPI.dispatch(notification({
          title: `${response.data.message}`,
          message: ``,
          type: `warning`
        }));
      }
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const getCustomerId = createAsyncThunk("getCustomerId", async (payload, thunkAPI) => {
  let userId = getCustomer();
  try {
    let response = await axiosChargebee.get(`/v1/users/${userId}`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      localStorage.clear();
      window.location.href = "/";
      return
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const otpGeneration = createAsyncThunk("otpGeneration", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.get(`/v1/generate-otp?email=${payload.email}&app=${appName}&name=${payload.name}`);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({
        title: `OTP send to email`,
        message: `${response.data.message}`,
        type: `success`
      }));
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const verifyOtp = createAsyncThunk("verifyOtp", async (payload, thunkAPI) => {
  payload.app = appName
  try {
    let response = await axiosChargebee.post(`/v1/customer-otp`, payload);
    if (response && response.data && response.data.success) {
      setCustomer(payload.customerId);
      setAuth(response.data.token);
      return response.data
    } else {
      thunkAPI.dispatch(notification({
        title: `OTP does not match`,
        message: `${response.data.message}`,
        type: `warning`
      }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})